import { render } from "./ListTeachersVideo.vue?vue&type=template&id=280c3d06&scoped=true"
import script from "./ListTeachersVideo.vue?vue&type=script&lang=js"
export * from "./ListTeachersVideo.vue?vue&type=script&lang=js"

import "./ListTeachersVideo.vue?vue&type=style&index=0&id=280c3d06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280c3d06"]])

export default __exports__